import { isWeekend, addDays, differenceInCalendarDays, startOfDay } from 'date-fns';

/**
 * Counts working days (Mon–Fri) between startDate and endDate (inclusive of start).
 */
export function countWorkingDays(startDate, endDate) {
  if (!startDate || !endDate) return 0;
  const start = startOfDay(new Date(startDate));
  const end = startOfDay(new Date(endDate));
  const totalDays = differenceInCalendarDays(end, start);
  if (totalDays <= 0) return 0;

  let working = 0;
  let cursor = new Date(start);
  for (let i = 0; i < totalDays; i++) {
    if (!isWeekend(cursor)) working++;
    cursor = addDays(cursor, 1);
  }
  return working;
}

/**
 * Returns working days elapsed since a Firestore timestamp or Date.
 */
export function workingDaysSince(since) {
  if (!since) return 0;
  const start = since.toDate ? since.toDate() : new Date(since);
  return countWorkingDays(start, new Date());
}

/**
 * Returns a working-day deadline N working days from startDate.
 */
export function addWorkingDays(startDate, workingDays) {
  let cursor = new Date(startDate);
  let added = 0;
  while (added < workingDays) {
    cursor = addDays(cursor, 1);
    if (!isWeekend(cursor)) added++;
  }
  return cursor;
}

/**
 * Returns SLA status string based on days elapsed vs target.
 * 'green' | 'amber' | 'red'
 */
export function getSLAStatus(daysElapsed, targetDays) {
  if (daysElapsed >= targetDays) return 'red';
  if (daysElapsed >= targetDays - 1) return 'amber';
  return 'green';
}
